import {PhoneNumberUtil} from 'google-libphonenumber';
import {MINIMUM_FIELD_LENGTH} from '../constants/constant';

export const validateRequired = (value) => value ? null : 'required';

export const validateMinimumLength = (value) => value.length > MINIMUM_FIELD_LENGTH ? null : 'checkout.minimumLengthError';

export const validateEmail = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'checkout.consumerInvalidEmailError'
    : null;

const isValidNumber = (value) => {
  const DOUBLE_ZEROS = '00';
  const PLUS_SIGN = '+';
  const DEFAULT_REGION = 'GB';
  const region = (value.startsWith(PLUS_SIGN) || value.startsWith(DOUBLE_ZEROS)) ? '' : DEFAULT_REGION;

  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    const parsedNumber = phoneUtil.parse(value, region);
    return phoneUtil.isValidNumber(parsedNumber);
  } catch (e) {
    return false;
  }
};

export const validateTelephone = (value) => {
  return value &&
  !isValidNumber(value)
    ? 'checkout.consumerInvalidPhoneError'
    : null;
};

export const exceedLimit = max => value => value > max ?
  {
    id: 'booking.exceedLimit',
    props: {max}
  } : null;

export const lessThan = max => value => value < max ? value : max;



// WEBPACK FOOTER //
// ./helpers/formValidation.helper.js